import { formatFileSize } from '@/utils/format-file-size';

export const getFileSizeError = (file: File, maxBytes: number): string | null => {
  if (file.size <= maxBytes) return null;
  return `Maximum size is ${formatFileSize(maxBytes)}. Selected file is ${formatFileSize(file.size)}.`;
};
